import type { PortalFeatureAvailabilityDto } from '@erp/shared';
import { createContext, useContext } from 'react';

export const PortalFeatureContext = createContext<PortalFeatureAvailabilityDto | null>(null);

export function usePortalFeatureAvailability(): PortalFeatureAvailabilityDto {
  const value = useContext(PortalFeatureContext);
  if (value === null) throw new Error('PortalFeatureAvailabilityProvider is missing.');
  return value;
}
